module.exports = __webpack_public_path__ + "img/logoImg.a73bdeff.png";